import { useAccount } from '@azure/msal-react';
import { Link } from '@mui/material';
import React from 'react';

const LoggedUser = () => {
    const account = useAccount();
    return (
        <Link
            sx={{
                color: (t) => t.palette.primary.main,
                fontSize: 12
            }}>
            {account?.name}
        </Link>
    );
};

export default LoggedUser;
